import {onMounted, onUnmounted} from "vue";

export function useSingleRowItems() {
    const wrappers = new Map();

    function calcVisible(wrapper) {
        const items = [...wrapper.querySelectorAll('[data-row-item]')];
        if (!items.length) return;

        items.forEach(el => (el.style.display = ''));

        const firstTop = items[0].getBoundingClientRect().top;
        let count = 0;
        for (const item of items) {
            if (item.getBoundingClientRect().top !== firstTop) break;
            count++;
        }

        items.forEach((el, i) => {
            if (i >= count) el.style.display = 'none';
        });
    }

    function onResize() {
        wrappers.forEach(el => calcVisible(el));
    }

    onMounted(() => window.addEventListener('resize', onResize));
    onUnmounted(() => window.removeEventListener('resize', onResize));

    function rowRef(el, key) {
        if (!el) {
            wrappers.delete(key);
            return;
        }
        if (wrappers.get(key) === el) return;
        wrappers.set(key, el);
        requestAnimationFrame(() => calcVisible(el));
    }

    return {rowRef};
}
